import { cognitoAuth } from '../../CognitoAuth';
import { logoutIntercomUser } from '../../IntercomUtilityFunctions';
import { logger } from '../../error-tracker';
import { getStore } from '../../ApplicationState';
import { setMessageMark as setMessageMarkBackend } from '../../BackendInterface';
import { getUsersId, getUsersMessageMark } from '../../GlobalFunctions';
import { logout, updateField } from '../../UserManagement';
import { setMessageMark as setMessagesMessageMark } from '../../Messages';

export const setMessageMark = async (newMessageMark: number = Date.now()) => {
  const userId = getUsersId();
  if (!userId) return;
  const store = getStore();
  await setMessageMarkBackend(userId, newMessageMark);

  // An out-of-order resolution (a newer call finishing before this older one)
  // must not regress the profile's mark back down.
  const currentProfileMark = getUsersMessageMark();
  if (!currentProfileMark || newMessageMark > currentProfileMark) {
    store.dispatch(updateField({ field: 'messageMark', value: newMessageMark }));
  }

  store.dispatch(setMessagesMessageMark(newMessageMark));
};

export const cognitoSignOut = () => {
  cognitoAuth
    .signOut()
    .then((_data) => {
      getStore().dispatch(logout());
      logoutIntercomUser();
    })
    .catch((error) => {
      logger.logException(error);
    });
};

export const unionArray = (...subArray) => {
  let union = [];
  for (const array of subArray) {
    union = [...new Set([...union, ...(array || [])])];
  }
  return union;
};

export const differenceArray = (diffArray, ...subArray) => {
  let difference = [];
  for (const array of subArray) {
    difference = (array || []).filter((x) => diffArray.indexOf(x) < 0);
  }
  return difference;
};

export const numericGradeToString = {
  '-1': 'Pre-Kindergarten',
  0: 'Kindergarten',
  1: 'Grade 1',
  2: 'Grade 2',
  3: 'Grade 3',
};
